import { useCallback } from 'react';

export function usePolar() {
  const openCheckout = useCallback(async (checkoutUrl: string) => {
    // Dynamically import to avoid loading Polar code when using Paddle
    const { PolarEmbedCheckout } = await import('@polar-sh/checkout/embed');

    PolarEmbedCheckout.create(checkoutUrl, {
      theme: 'light',
    });
  }, []);

  return { openCheckout };
}
